import { useQuery } from "react-query";
import http from "infra/http";
import URL from "core/resources/urls";

const useGetConfiguracaoNotificacoes = () => {
  return useQuery({
    queryKey: [URL.CONFIGURACAO_NOTIFICACOES.OBTER],
    queryFn: async () => {
      const { data } = await http.get<any, any>(URL.CONFIGURACAO_NOTIFICACOES.OBTER);
      return data;
    },
    keepPreviousData: true,
  });
};

export default useGetConfiguracaoNotificacoes;
